import React from 'react'
import i18next from 'i18next'
import moment from 'moment'
import {Button, Modal} from 'antd'
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    TabletOutlined,
    DesktopOutlined,
    MobileOutlined,
    RobotOutlined,
    QuestionOutlined
} from '@ant-design/icons'
import {TwoFATrustedDeviceType} from '@/stores/profile/models'
import {DATE_FORMAT, TIME_FORMAT} from '@/constants'

import styles from '../styles.scss'
import {DELETE_DEVICE} from '@/constants/playwright-ids'

const icons: () => Record<TwoFATrustedDeviceType, React.ReactElement> = () => ({
    Tablet: <TabletOutlined title={i18next.t('TwoFADevices.tablet')} />,
    Desktop: <DesktopOutlined title={i18next.t('TwoFADevices.desktop')} />,
    Mobile: <MobileOutlined title={i18next.t('TwoFADevices.mobile')} />,
    Bot: <RobotOutlined title={i18next.t('TwoFADevices.bot')} />,
    Unknown: <QuestionOutlined />
})

const columns = () => [
    {
        title: i18next.t('TwoFADevices.columns.device'),
        dataIndex: 'name',
        key: 'name',
        width: '50%',
        render: (value, {deviceType}) => {
            return (
                <div className={styles.device}>
                    {icons()[deviceType] && <div className={styles.icon}>{icons()[deviceType]}</div>}{' '}
                    {value}
                </div>
            )
        }
    },
    {
        title: i18next.t('TwoFADevices.columns.addedOn'),
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: '25%',
        render: date => date && moment(date).format(`${DATE_FORMAT} | ${TIME_FORMAT}`)
    },
    {
        title: i18next.t('TwoFADevices.columns.lastLogin'),
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        width: '25%',
        render: date => date && moment(date).format(`${DATE_FORMAT} | ${TIME_FORMAT}`)
    }
]

export const getColumns = (deleteDevice: (id: string) => Promise<void>) => {
    return [
        ...columns(),
        {
            key: 'actions',
            render: ({id}) => (
                <Button
                    title={i18next.t('TwoFADevices.delete')}
                    icon={<DeleteOutlined />}
                    size={'small'}
                    shape='circle'
                    onClick={() => {
                        Modal.confirm({
                            width: '500px',
                            icon: <ExclamationCircleOutlined />,
                            content: i18next.t('TwoFADevices.messages.confirm'),
                            okText: i18next.t('TwoFADevices.yes'),
                            cancelText: i18next.t('TwoFADevices.no'),
                            onOk: async () => {
                                await deleteDevice(id)
                            }
                        })
                    }}
                    data-test-id={DELETE_DEVICE}
                ></Button>
            )
        }
    ]
}
